import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from '../detail.module.less';

/**
 * 价格类型
 */
const PRICE_TYPE_EMU = {
  QUOTATION: 1, // 报价单
  PRICE: 2, // 一口价
  INTERVAL: 3, // 区间价格
  COMBINATION: 4, // 组合价
};

const colorArr = [
  {
    background: 'rgba(66,112,255,0.1)',
    fontColor: '#4270FF',
  },
  {
    background: 'rgba(56,168,255,0.1)',
    fontColor: '#33A6FF',
  },
  {
    background: 'rgba(254,244,189,0.7)',
    fontColor: '#DCB403',
  },
];

const propTypes = {
  mainInfoObj: PropTypes.shape({
    priceType: PropTypes.number,
    intervalPriceLeft: PropTypes.number,
    intervalPriceRight: PropTypes.number,
    proposal: PropTypes.string,
    price: PropTypes.number,
    specification: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      price: PropTypes.number,
    })),
    templateType: PropTypes.number,
    labels: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

const defaultProps = {
};

class mainInfo extends React.Component {
  // 随机生成RGB颜色
  static randomRgbColor(index) {
    const colorIndex = index % 3;

    return colorArr[colorIndex];
  }

  constructor(props) {
    super(props);
    this.state = {
      // currentPage: 1,
    };
  }

  renderPrice = () => {
    const { mainInfoObj } = this.props;
    const {
      priceType,
      intervalPriceLeft,
      intervalPriceRight,
      proposal,
      price,
      specification,
      templateType,
    } = mainInfoObj;

    if (templateType === 4) {
      // 如果是开户模式 没有此选项
      return null;
    }
    let specificationPrice;
    switch (priceType) {
      case PRICE_TYPE_EMU.QUOTATION:
        return <Link to={`/filepreview?fileurl=${proposal}`}>报价单</Link>;
      case PRICE_TYPE_EMU.PRICE:
        return price ? `¥ ${(Number(price) / 100).toFixed(2)}` : 0;
      case PRICE_TYPE_EMU.INTERVAL:
        return `¥ ${intervalPriceLeft / 100}-${intervalPriceRight / 100}`;
      case PRICE_TYPE_EMU.COMBINATION:
        specificationPrice = specification[0].price;
        return specificationPrice ? `¥ ${(Number(specificationPrice) / 100).toFixed(2)}` : '0.00';
      default:
    }
    return true;
  }

  render() {
    const { mainInfoObj } = this.props;
    const obj = mainInfoObj;
    let tagList = null;
    if (obj.labels.length > 0) {
      tagList = obj.labels.map((item, index) => {
        const colorStr = mainInfo.randomRgbColor(index);
        return (
          <li
            className={styles.tag}
            key={item}
            style={{
              background: colorStr.background,
              color: colorStr.fontColor,
            }}
          >
            {item}
          </li>
        );
      });
    }
    return (
      <div className={styles.main_box}>
        <p className={styles.price}>{this.renderPrice()}</p>
        <p className={styles.title}>{obj.name}</p>
        <p className={styles.desc}>{obj.highlight}</p>
        <ul>{tagList}</ul>
      </div>
    );
  }
}

mainInfo.propTypes = propTypes;
mainInfo.defaultProps = defaultProps;

export default mainInfo;
